// Copyright © 2026 Alex Bruce. All rights reserved.
// Proprietary and confidential. Unauthorized copying, modification,
// or distribution is strictly prohibited.

import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

export type Plan = "base" | "premium";

export interface Entitlements {
  plan: Plan;
  canUseBids: boolean;
  canUseInsights: boolean;
  canUseAI: boolean;
  canUseCashflow: boolean;
  canUseRfi: boolean;
}

const PREMIUM: Entitlements = {
  plan: "premium",
  canUseBids: true,
  canUseInsights: true,
  canUseAI: true,
  canUseCashflow: true,
  canUseRfi: true,
};

const BASE: Entitlements = {
  plan: "base",
  canUseBids: false,
  canUseInsights: false,
  canUseAI: false,
  canUseCashflow: false,
  canUseRfi: false,
};

export function useEntitlements(userId: string | null | undefined): Entitlements {
  const [entitlements, setEntitlements] = useState<Entitlements>(PREMIUM);

  useEffect(() => {
    if (!userId || !supabase) return;
    supabase
      .rpc("get_my_plan")
      .then(({ data, error }) => {
        if (!error && data === "base") setEntitlements(BASE);
      });
  }, [userId]);

  return entitlements;
}
